import React from 'react'
import PropTypes from 'prop-types'

import FormControl from '../FormControl'
import TextFieldWrapper from './TextFieldWrapper'
import TextFieldLabel from './TextFieldLabel'
import Input from '../Input'
import FieldHelp from '../FieldHelp'

function TextField({
  name,
  id = name,
  label,
  shrinkLabel,
  full,
  error,
  tip,
  forceTip,
  help,
  ...props
}) {
  return (
    <FormControl>
      {({ focused, filled, getInputProps }) => (
        <TextFieldWrapper full={full}>
          {label && (
            <TextFieldLabel
              shrink={shrinkLabel || focused || filled}
              focused={focused}
              htmlFor={id}
              error={error}
            >
              {label}
            </TextFieldLabel>
          )}
          <Input
            {...getInputProps({
              ...props,
              error,
              focused,
              filled,
              id,
              name
            })}
          />
          {(focused || forceTip) && tip && <FieldHelp>{tip}</FieldHelp>}
          {help && <FieldHelp error={error}>{help}</FieldHelp>}
        </TextFieldWrapper>
      )}
    </FormControl>
  )
}

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.node,
  shrinkLabel: PropTypes.bool,
  full: PropTypes.bool,
  error: PropTypes.bool
}

export default TextField
